import React, { useContext } from 'react';
import { IBreadcrumb } from '../../interfaces';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { MarketContext } from '../../context/markets';
import * as Colors from '../../consts/variables';
import styled from '@emotion/styled';

type IProps = {
    breadcrumbs: IBreadcrumb[];
    sections: React.ReactNode;
};

const SectionsWrapper = styled.div`
    overflow: auto;
    background-color: ${(props: { isGray: boolean }) =>
        props.isGray ? Colors.lightGray : 'transparent'};
`;

const BreadcrumbsWrapper = styled.div`
    margin: 0px 15px 60px 15px;
`;

export const CompanyMobileDetails = (props: IProps) => {
    const { breadcrumbs, sections } = props;
    const { markets } = useContext(MarketContext);
    const { isCruise1st } = markets;

    let mobileSectionsPosition = [
        'zoneRecommendation',
        'description',
        'gallery',
        'ships',
        'seo',
        'form',
        'advisor',
        'reviews',
    ];
    if (isCruise1st) {
        mobileSectionsPosition = [
            'zoneRecommendation',
            'description',
            'gallery',
            'ships',
            'seo',
            'form',
            'advisor',
            'reviews',
        ];
    }
    return (
        <SectionsWrapper isGray={isCruise1st}>
            {mobileSectionsPosition.map((item) => sections[item]?.())}
            <BreadcrumbsWrapper>
                <Breadcrumbs breadcrumbs={breadcrumbs} />
            </BreadcrumbsWrapper>
        </SectionsWrapper>
    );
};
